import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Button, Modal, Form } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Deposit = () => {
    const [deposits, setDeposits] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('add');
    const [formData, setFormData] = useState({ title: '', from_price: '', to_price: '', image: null, id: null });
    const [imagePath, setImagePath] = useState('');


    useEffect(() => {
        fetchDeposits();
    }, []);

    const fetchDeposits = () => {
        axios.get("https://deadlox.badskullgaming.com/api/get-deposit")
            .then(response => {
                if (response.data && Array.isArray(response.data.deposit)) {
                    setDeposits(response.data.deposit);
                    setImagePath(response.data.imagePath);
                } else {
                    setDeposits([]);
                }
            })
            .catch(error => {
                console.error("Error fetching deposit data:", error);
                toast.error("Failed to fetch deposit data.");
            });
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const handleFileChange = (e) => {
        setFormData({ ...formData, image: e.target.files[0] });
    };


    const handleOpenModal = (type, deposit = null) => {
        setModalType(type);
        if (type === 'edit' && deposit) {
            setFormData({ title: deposit.title, from_price: deposit.from_price, to_price: deposit.to_price, image: null, id: deposit.id });
        } else {
            setFormData({ title: '', from_price: '', to_price: '', image: null, id: null });
        }
        setShowModal(true);
    };


    const handleCloseModal = () => {
        setShowModal(false);
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        const formDataObj = new FormData();
        formDataObj.append('title', formData.title);
        formDataObj.append('from_price', formData.from_price);
        formDataObj.append('to_price', formData.to_price);
        if (formData.image) {
            formDataObj.append('image', formData.image);
        }

        if (modalType === 'add') {
            axios.post("https://deadlox.badskullgaming.com/api/store-deposit", formDataObj)
                .then(() => {
                    toast.success("Deposit added successfully!");
                    fetchDeposits();
                    handleCloseModal();
                })
                .catch(error => {
                    console.error("Error adding deposit:", error);
                    toast.error("Failed to add deposit.");
                });
        } else if (modalType === 'edit') {
            axios.put(`https://deadlox.badskullgaming.com/api/update-deposit/${formData.id}`, formDataObj)
                .then(() => {
                    toast.success("Deposit updated successfully!");
                    fetchDeposits();
                    handleCloseModal();
                })
                .catch(error => {
                    console.error("Error updating deposit:", error);
                    toast.error("Failed to update deposit.");
                });
        }
    };


    const handleDelete = (id) => {
        axios.delete(`https://deadlox.badskullgaming.com/api/deletedeposit/${id}`)
            .then(() => {
                setDeposits(deposits.filter(deposit => deposit.id !== id));
                toast.success("Deposit deleted successfully!");
            })
            .catch(error => {
                console.error("Error deleting deposit:", error);
                toast.error("Failed to delete deposit.");
            });
    };

    return (
        <>
            <div className="container">
                <div className="d-flex justify-content-between my-3">
                    <h2>Deposit Data</h2>
                    <Button onClick={() => handleOpenModal('add')} variant="primary" className="mb-3 btn-primary">Add Deposit</Button>
                </div>

                {deposits.length > 0 ? (
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Title</th>
                                <th>From Price</th>
                                <th>To Price</th>
                                <th>Image</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {deposits.map((deposit, index) => (
                                <tr key={deposit.id}>
                                    <td>{index + 1}</td>
                                    <td>{deposit.title}</td>
                                    <td>{deposit.from_price}</td>
                                    <td>{deposit.to_price}</td>
                                    <td>
                                        <img src={`${imagePath}/${deposit.image}`} alt={deposit.title} style={{ width: '100px' }} />
                                    </td>
                                    <td>
                                        <Button variant="warning" onClick={() => handleOpenModal('edit', deposit)}>Edit</Button>{' '}
                                        <Button variant="danger" onClick={() => handleDelete(deposit.id)}>Delete</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <p>No deposit data available.</p>
                )}
            </div>

            {/* Modal for Add/Edit Deposit */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalType === 'add' ? 'Add Deposit' : 'Edit Deposit'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formTitle">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter title"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formFromPrice" className="mt-3">
                            <Form.Label>From Price</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Enter from price"
                                name="from_price"
                                value={formData.from_price}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formToPrice" className="mt-3">
                            <Form.Label>To Price</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Enter to price"
                                name="to_price"
                                value={formData.to_price}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formImage" className="mt-3">
                            <Form.Label>Image</Form.Label>
                            <Form.Control
                                type="file"
                                name="image"
                                onChange={handleFileChange}
                                accept="image/*"
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="mt-3">
                            {modalType === 'add' ? 'Add Deposit' : 'Update Deposit'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Toast container */}
            <ToastContainer />
        </>
    );
};

export default Deposit;
